export default __webpack_public_path__ + "static/media/dollar.cb3807bd.svg";